(function (window, document) {
  'use strict';

  var P = window.Printara = window.Printara || {};

  function query(selector, root) {
    return (root || document).querySelector(selector);
  }

  function queryAll(selector, root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll(selector)
    );
  }

  function parseNumber(value) {
    if (value === null || value === undefined || value === '') return 0;

    var match = String(value)
      .replace(/,/g, '')
      .match(/-?\d+(?:\.\d+)?/);

    return match ? parseFloat(match[0]) : 0;
  }

  function formatNumber(value, decimals) {
    var number = Number(value);
    var places = decimals === undefined ? 3 : decimals;

    if (!isFinite(number)) return '';

    return Number.isInteger(number)
      ? String(number)
      : number.toFixed(places).replace(/0+$/, '').replace(/\.$/, '');
  }

  function normalizeText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function parseMoneyText(raw) {
    if (!raw) return null;

    var cleaned = String(raw).replace(/\s+/g, ' ').trim();
    var match = cleaned.match(
      /[-+]?\d{1,3}(?:[,.]\d{3})*(?:[,.]\d{2})|[-+]?\d+(?:[.,]\d+)?/
    );

    if (!match) return null;

    var numeric = match[0];

    if (numeric.indexOf(',') > -1 && numeric.indexOf('.') > -1) {
      numeric = numeric.replace(/,/g, '');
    } else if (numeric.indexOf(',') > -1) {
      numeric = numeric.replace(',', '.');
    }

    var amount = parseFloat(numeric);
    if (isNaN(amount)) return null;

    return {
      amount: amount,
      currencyPrefix: cleaned.slice(0, match.index).trim() || '$'
    };
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function getProductForms(root) {
    return queryAll('form[action*="/cart/add"]', root || document);
  }

  function getProductForm(root) {
    if (root && root.closest) {
      var closest = root.closest('form[action*="/cart/add"]');
      if (closest) return closest;
    }

    return getProductForms()[0] || null;
  }

  function propertySelector(name) {
    return '[name="properties[' + String(name).replace(/"/g, '\\"') + ']"]';
  }

  function propertyInputs(name, root) {
    return queryAll(propertySelector(name), root || document);
  }

  function getPropertyValue(name, root) {
    var value = '';

    propertyInputs(name, root).forEach(function (input) {
      if (
        input.value !== undefined &&
        input.value !== null &&
        String(input.value).trim() !== ''
      ) {
        value = String(input.value).trim();
      }
    });

    return value;
  }

  function ensurePropertyInput(form, name, marker) {
    if (!form) return null;

    var input = marker
      ? form.querySelector('[data-printara-property="' + marker + '"]')
      : null;

    if (!input) {
      input = form.querySelector(propertySelector(name));
    }

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      form.appendChild(input);
    }

    input.name = 'properties[' + name + ']';

    if (marker) {
      input.setAttribute('data-printara-property', marker);
    }

    return input;
  }

  function setProperty(form, name, value, options) {
    options = options || {};

    var input = ensurePropertyInput(form, name, options.marker);
    if (!input) return null;

    var hasValue =
      value !== undefined &&
      value !== null &&
      String(value).trim() !== '';

    input.value = hasValue ? String(value).trim() : '';

    if (options.disableWhenEmpty) {
      input.disabled = !hasValue;
    } else if (hasValue) {
      input.disabled = false;
    }

    return input;
  }

  function setPropertyAll(name, value, options) {
    getProductForms().forEach(function (form) {
      setProperty(form, name, value, options);
    });
  }

  function getVariantId(form) {
    var scope = form || document;

    var checked = scope.querySelector('input[name="id"]:checked');
    if (checked && checked.value) return checked.value;

    var select = scope.querySelector('select[name="id"]');
    if (select && select.value) return select.value;

    var hidden = scope.querySelector('input[name="id"]');
    if (hidden && hidden.value) return hidden.value;

    if (scope !== document) {
      var globalForm = getProductForm();
      if (globalForm && globalForm !== form) {
        return getVariantId(globalForm);
      }
    }

    try {
      return new URL(window.location.href).searchParams.get('variant') || '';
    } catch (error) {
      return '';
    }
  }

  function getProductData(root) {
    var element = query('[data-printara-product-data]', root || document);
    if (!element) return null;

    try {
      return JSON.parse(element.textContent || 'null');
    } catch (error) {
      console.warn('Printara product data could not be parsed.', error);
      return null;
    }
  }

  function emit(name, detail) {
    document.dispatchEvent(
      new CustomEvent(name, {
        detail: detail || {}
      })
    );
  }

  function schedule(fn, delays) {
    (delays || [0]).forEach(function (delay) {
      window.setTimeout(fn, delay);
    });
  }

  P.util = {
    query: query,
    queryAll: queryAll,
    parseNumber: parseNumber,
    formatNumber: formatNumber,
    normalizeText: normalizeText,
    parseMoneyText: parseMoneyText,
    ready: ready,
    schedule: schedule
  };

  P.forms = {
    all: getProductForms,
    first: getProductForm,
    propertyInputs: propertyInputs,
    getPropertyValue: getPropertyValue,
    ensurePropertyInput: ensurePropertyInput,
    setProperty: setProperty,
    setPropertyAll: setPropertyAll
  };

  P.product = {
    getVariantId: getVariantId,
    getData: getProductData
  };

  P.emit = emit;
})(window, document);
